import React, { useState, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router';
import styled from "styled-components";
import {Classes, Spinner} from "@blueprintjs/core";

import {LIGHT_GRAY_BLUE} from "../../styles/constants";
import { auth0Init, checkAuth } from '../../services/auth0';


// ---------------------- Authenticated Routes
const Wrapper = styled.section`
  padding: 2em;
  background: ${LIGHT_GRAY_BLUE};
  width: 100%;
  text-align: center;
  height: 100vh;
`;

const PreInitLoading = () => (
    <Wrapper>
      <Spinner className={Classes.SMALL} />
    </Wrapper>
);


// ---------------------- Auth0Wrapper
const AuthWrapper = ({ children }) => {
    const [ready, setReady] = useState(false);

    useEffect(() => {
        auth0Init().then((auth0Client) => {
            const { search } = window.location;
            if (search.includes('code=') && search.includes('state=')) {
                auth0Client.handleRedirectCallback().then(() => {
                    window.history.replaceState(null, '', window.location.pathname);
                }).catch(() => {
                    window.history.replaceState(null, '', window.location.pathname);
                }).finally(() => {
                    setReady(true);
                });
            } else {
                setReady(true);
            }

        });
    }, []);

    return (ready ? children : <PreInitLoading />)
}


// ---------------------- Authenticated Layout Route
const AuthenticatedRoute = ({login}) => {
    const [authCheckComplete, setAuthCheckComplete] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        checkAuth().then((result) => {
            setAuthCheckComplete(true);
            setIsAuthenticated(result);
        });
    }, []);

    if (!authCheckComplete) return <PreInitLoading />;
    if (!isAuthenticated) return <Navigate to={login} />;
    return <Outlet />;
};


export { PreInitLoading, AuthWrapper, AuthenticatedRoute };
